'use strict';

var initialized = false;


/**
 * @private
 * @function
 * @description Initializes events for component
 */
function initializeEvents() {
	$('body')
	.on('click', '.js-filter_by-button', function(e) {
		e.preventDefault();
		$(e.delegateTarget).toggleClass('js-refinements_opened');
		$('.js-sort_by-button').removeClass('expanded');
	})
	.on('click', '.js-sort_by-button', function(e) {
		$(e.delegateTarget).removeClass('js-refinements_opened');
	});
}


module.exports = {
	init : function (params) {
		if (initialized) return;
		initializeEvents();
		initialized = true;
	}
}
